import { AddMainProductFormValues } from "./types";
import { defaultFormValues, schema } from "./constants";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
export interface AddMainProductFormProviderProps {
  defaultValues?: Partial<AddMainProductFormValues>;
  children?: React.ReactNode;
}

export const AddMainProductFormProvider = ({
  defaultValues,
  children,
}: AddMainProductFormProviderProps) => {
  const normalizedDefaultValues: Partial<AddMainProductFormValues> =
    React.useMemo(() => {
      return {
        ...defaultFormValues,
        ...defaultValues,
      };
    }, []);

  const methods = useForm<AddMainProductFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: normalizedDefaultValues,
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
